// Script for the page `ui/system/messages`
// Makes some select boxes look nicer.

import { classList, type TElementSpecifier, toJQuery } from "@de-xima/xima-common-js-dom";

/**
 * @param callback Called when the select one menu changes.
 * @param element The select one menu that changed.
 */
function onSelectOneMenuChange(
  callback: (customLabel: JQuery, select: JQuery) => void,
  element: TElementSpecifier<HTMLElement>,
): void {
  const $element = toJQuery(element);
  const $selectOneMenu = $element.closest(".ui-selectonemenu");
  if ($selectOneMenu.length < 1) {
    console.warn("No SelectOneMenu found");
    return;
  }
  const $label = $selectOneMenu.find(".ui-selectonemenu-label");
  const $select = $selectOneMenu.find("select");
  let $customLabel = $label.siblings(".ui-selectonemenu-label-custom");
  if ($customLabel.length < 1) {
    $customLabel = $label.clone(true, false);
    $customLabel.addClass("ui-selectonemenu-label-custom");
    $label.hide();
    $label.after($customLabel);
  }
  callback($customLabel, $select);
}

/**
 * Converts the label (the icon name) to the actual icon.
 * @param $selectOneMenu Select one menu element that changed.
 * @param $label Label of the item that is now selected.
 * @param $select Select element of the item that is now selected.
 */
function onIconChangeBase($label: JQuery, $select: JQuery): void {
  const iconId = $select.val();
  const classes = classList($label).filter((clazz) => !clazz.startsWith("ico-") && clazz !== "icon");
  if (typeof iconId === "string") {
    classes.push("icon");
    classes.push(iconId);
    $label.text("");
  }
  $label.attr("class", classes.join(" "));
}

/**
 * Converts the label into a preview of the color.
 * @param $selectOneMenu Select one menu element that changed.
 * @param $label Label of the item that is now selected.
 * @param $select Select element of the item that is now selected.
 */
function onColorChangeBase($label: JQuery, $select: JQuery): void {
  const color = $select.val();
  if (typeof color === "string" || typeof color === "number") {
    const span = document.createElement("span");
    span.setAttribute("class", "ui-color-options");
    span.setAttribute("style", `background-color: ${color};`);
    $label.empty();
    $label.append(span);
  } else {
    $label.empty();
  }
}

/**
 * Callback for a SelectOneMenu's `onchange` handler that converts the label
 * into a preview of the color.
 */
export function onColorChange(element: TElementSpecifier<HTMLElement>): void {
  onSelectOneMenuChange(onColorChangeBase, element);
}

/**
 * Callback for a SelectOneMenu's `onchange` handler that converts the label
 * (the icon name) to the actual icon
 */
export function onIconChange(element: TElementSpecifier<HTMLElement>): void {
  onSelectOneMenuChange(onIconChangeBase, element);
}
